(function() {
    'use strict';

    a3_cabin_reports.controller('CrewContactsModalCtrl', CrewContactsModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name CrewContactsModalCtrl
     * @description 
     * Shows crew detais with contacts 
     * @ngInject
     */

    function CrewContactsModalCtrl($scope, $timeout, $uibModalInstance, crewInfo, selectedflightid, selectedFlightNo){
        $scope.crew = crewInfo;
        $scope.selectedflightid = selectedflightid;
        $scope.closeCrewPanel = closeCrewPanel;
        $scope.selectedFlightNo = selectedFlightNo;
        /**
         * Close the modal 
         * @memberof BucketModalCtrl
         */
        function closeCrewPanel(){
            $uibModalInstance.close();
        }

     
    }
})();